const Landingpage = () =>
  import(/* webpackChunkName: "landingpage" */ '../views/Landingpage.vue')

const LandingpageRoute = [
  {
    path: '/landing/:id',
    name: 'landingpage',
    component: Landingpage,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Landingpage',
    },
  },
]

export default LandingpageRoute
